var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowForwardIos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow_forward_ios_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m161.02,114.28c4.69-4.69,12.28-4.69,16.97,0l91,91c2.66,2.66,3.8,6.25,3.45,9.72.36,3.47-.79,7.06-3.45,9.72l-91,91c-2.34,2.34-5.41,3.51-8.49,3.51s-6.14-1.17-8.49-3.51c-4.69-4.69-4.69-12.28,0-16.97l83.75-83.75-83.75-83.75c-4.69-4.69-4.69-12.28,0-16.97Z",
    style: {
      fill: "#f7f7f7"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardIos);
export default __webpack_public_path__ + "static/media/arrow_forward_ios.6461f1fcd8296928a078b948a01c4ac2.svg";
export { ForwardRef as ReactComponent };